import { useMutation } from '@tanstack/react-query';

import { Endpoints } from '@/api';
import { useFetch } from '@/utils/fetch';

export const useCreateSessionLimitedToken = () => {
  const fetch = useFetch<Endpoints['POST /sessions/current/limited']>();

  return useMutation({
    mutationFn: () => {
      return fetch(`/sessions/current/limited`, undefined, {
        method: 'POST',
      });
    },
  });
};
